import $ from 'jquery';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {ZENDESK_GUIDE_URL} from 'nav/ZendeskConstants';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export function initHelpContainer(): void {
  if (!BenchlingConfig.ENABLE_IN_APP_SUPPORT) {
    const $helpContainerNode = $('.helpContainer-mount');
    renderToDOM(<HelpButton />, $helpContainerNode[0]);
  }
}

export function HelpButton(): JSX.Element {
  return (
    <div className="helpContainer">
      <a
        href={BenchlingConfig.ENABLE_ZENDESK_GUIDE ? ZENDESK_GUIDE_URL : BenchlingConfig.SUPPORT_SITE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="helpContainer-icon">
          <BenchlingIcon icon="question" />
        </span>
      </a>
    </div>
  );
}
